module.exports = __webpack_public_path__ + "static/img/case_detail_17_3.bf5e4cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_17_3.png
// module id = y6QG
// module chunks = 34